module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAAAsSAAALEgHS3X78AAABEUlEQVRIDe2WYQ6CMAyFC/EgJlyAI3gT4QbrCdQT9AjovSQeBTMy4tjaAVJMTHh/IGN9HxusbWaMeQJAAWndiOiamoGI9vllwqfNZ8A0VdgVdoFhTUR3DQgiVgDQ+GO5d/9w18ZN1IQN3h8gEVVa0BDmvMdALWgKFgHXQqdgLJCBlnOBAGBSMBHoQe0fa6Q5TEzpYsRdOdhDnTBYfDwSMT0n67rwGG4rcUu30g7cgX8AtJXaVetIiHhcaijFDJzctQVRa+AS8euL5C3F9Bx2S4OsvyR5n9xVrDIRkCkxS5L3ZGkbAefUs7VQv4mq18KCl7dV4xx6+ytUgwGz0mE8/IYqMAHai+tLOWl13j/ONADtG+lJlpWRuqZDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/fullscreen.png
// module id = fl0p
// module chunks = 1